import React, { useEffect } from 'react';
import { IIDsShowInComboDishes } from '../../../../../../../../../editDishState/editDishContext';
import { IItemForGetShortInfo, IGetDishesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryId } from 'backend/dishes';
import MultipleSelect from './components/MultipleSelect';
import style from './ModificationDishMultipleSelect.module.scss';

interface IModificationDishMultipleSelect {
	setFetchedDishModifications: (Value: IItemForGetShortInfo[]) => void;
	selectedDishModificationSubCategory: Nullable<string>;
	setDishModifications: (value: string[]) => void;
	selectedDishModifications: string[];
	setIDsShowInComboDishes: (value: IIDsShowInComboDishes) => void;
	IDsShowInComboDishes: IIDsShowInComboDishes;
}

const ModificationDishMultipleSelect: React.FC<IModificationDishMultipleSelect> = ({
	selectedDishModifications,
	selectedDishModificationSubCategory,
	setFetchedDishModifications,
	setDishModifications,
	setIDsShowInComboDishes,
	IDsShowInComboDishes,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, string>(
		selectedDishModificationSubCategory ? getDishesShortBySubCategoryId : null,
		selectedDishModificationSubCategory || '',
	);

	useEffect(() => {
		refetch();
	}, [selectedDishModificationSubCategory]);

	useEffect(() => {
		if (response) {
			setFetchedDishModifications(response.data.dishes);
		}
	}, [response]);

	return (
		<div className={style.container}>
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.dishes || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					selectedDishModifications={selectedDishModifications}
					selectedDishModificationSubCategory={selectedDishModificationSubCategory}
					setDishModifications={setDishModifications}
					setIDsShowInComboDishes={setIDsShowInComboDishes}
					IDsShowInComboDishes={IDsShowInComboDishes}
				/>
			</div>
		</div>
	);
};

export default React.memo(ModificationDishMultipleSelect);
